module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alexandra Chauran\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Dr. Alexandra Chauran")]), _vm._v(", of Port Moody, Canada, received a master's degree in teaching from Seattle University and a doctorate from Valdosta State University. She is the author of dozens of books, including "), _c('I', [_vm._v("Crystal Ball Reading for Beginners")]), _vm._v(", "), _c('I', [_vm._v("Have You Been Hexed?")]), _vm._v(", and "), _c('I', [_vm._v("Getting Through It")]), _vm._v(". In her spare time she enjoys streaming on Twitch as QueenOfDiamonds and chatting with readers.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xZK9K8/image/cover.jpg?1731429783818",
      "alt": "This image is the cover for the book Faeries & Elementals for Beginners"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Faeries & Elementals for Beginners\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Explore the magical world where nature spirits dwell")])]), _c('p', [_vm._v("From sprites to will-o'-the-wisps, this practical beginner's guide introduces you to a wide assortment of wild and wondrous creatures. Discover how to attract faeries and elementals to your home and garden, as well as how to befriend them. Along with step-by-step instructions for safely finding and interacting with these powerful creatures, you'll also learn how to:")]), _vm._v("Identify faeries and elementals associated with each of the four classic elements—air, fire, water, and earthPerform rituals, meditations, and exercises that help you connect with nature spirits on a personal levelRequest help from faeries and elementals for healing, protection, getting a job, attracting love, and moreDetermine what roles nature spirits play in folklore and magic throughout the world\n    "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Llewellyn Publications is an imprint of Llewellyn Worldwide Ltd. \n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0